import './App.css';
import { useState } from 'react';
import { Connection, PublicKey, Keypair } from '@solana/web3.js';
// import * as anchor from "@project-serum/anchor";
import {
  Program, AnchorProvider
} from '@project-serum/anchor';
import rightscoinidl from './rightscoinidl.json';
import { PhantomWalletAdapter } from '@solana/wallet-adapter-wallets';
import { useWallet, WalletProvider, ConnectionProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
require('@solana/wallet-adapter-react-ui/styles.css');
// const spl_token_1 = require("@solana/spl-token");

const wallets = [
  /* view list of available wallets at https://github.com/solana-labs/wallet-adapter#wallets */
  new PhantomWalletAdapter()
]
const network = "https://api.devnet.solana.com";
let rightsClassAccount_timebased="ctfKT9yu4dXHifUDPn1tVQAzTAP5HZh7LiN7xGmn3fc";
let response = "";
 
const opts = {
  preflightCommitment: "processed"
}
const programID = new PublicKey(rightscoinidl.metadata.address);

function App() {
  const [value, setValue] = useState(null);
  const [error, setError] = useState(null);
  const wallet = useWallet();

  async function getProvider() {
    const connection = new Connection(network, opts.preflightCommitment);

    const provider = new AnchorProvider(
      connection, wallet, opts.preflightCommitment,
    );
    return provider;
  }

  async function disconnect() { 
    const provider = await getProvider(); // see "Detecting the Provider"
    try {
      provider.wallet.disconnect();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      //console.log(resp.publicKey.toString());
    } catch (err) {
      setError(err);
        // { code: 4001, message: 'User rejected the request.' }
    }
  }

  async function setReceiverRightsClass() { 
    const provider = await getProvider();
    const connection = new Connection(network, opts.preflightCommitment);
    //34qUG3L36gNmg39yFc4c3LMvg7pfnGJ8ht1CKRTotKRN
    const rightsClassAccount = new PublicKey(rightsClassAccount_timebased);
    console.log(rightsClassAccount.toString());
    const program = new Program(rightscoinidl, programID, provider);
    try {
      response =  await program.methods.setReceiverRightsClass()
        .accounts({
          rightsClass: rightsClassAccount,
          authority: provider.wallet.publicKey,
        })
      .rpc();
      //   var tx =  program.transaction.setReceiverRightsClass({
      //   accounts: {
      //     rightsClass: rightsClassAccount,
      //     authority: provider.wallet.publicKey,
      //   }
      // });
        //.signers([provider])
        //.rpc();
      // const latestBlockhash = await provider.connection.getLatestBlockhash();
      // tx.recentBlockhash = latestBlockhash.blockhash;
      // tx.feePayer = provider?.wallet.publicKey;
      // let signed = await provider?.wallet.signTransaction(tx);
      // const rawTransaction = signed.serialize()
      // console.log("rawTransaction: ", rawTransaction);
      //const keypair = anchor.web3.Keypair.fromSecretKey(secret);
      //const wallet_backend = new Wallet(keypair_backend);
      //const fullySignedTransaction = await wallet_backend.signTransaction(rawTransaction);
      //console.log("fullySignedTransaction: ", fullySignedTransaction);

      // const txid = await connection.sendRawTransaction(rawTransaction, {
      //   skipPreflight: true,
      //   maxRetries: 2
      // });
      console.log("signature: ", response);
      const rightsClass = await program.account.rightsClass.fetch(rightsClassAccount);
      console.log('rightsClass: ', rightsClass);
      setValue(true);
    } catch (err) {
      let index = err.toString().indexOf("Error Code:");
      let error_new = err.toString().substring(index);
      setError(error_new);
    }
  }

  // async function approveReceiverRightsCoin() { 
  //   const provider = await getProvider();
  //   const connection = new Connection(network, opts.preflightCommitment);
  //   //34qUG3L36gNmg39yFc4c3LMvg7pfnGJ8ht1CKRTotKRN
  //   const rightsClassAccount = new PublicKey(rightsClassAccount_timebased);
  //   console.log(rightsClassAccount.toString());
  //   const rightCoinMintAddress = new anchor.web3.PublicKey("DQotc7vgTk4D6bZhtsaim89YpaQtux8XqJocMaG4BXoT");
  //   const rightsCoinToATARec = await spl_token_1.getAssociatedTokenAddress(rightCoinMintAddress, provider.wallet.publicKey);
  //   const program = new Program(rightscoinidl, programID, provider);
  //   try {
  //     response =  await program.methods.approveOsqoTokenTimeBased()
  //         .accounts({
  //           rightsClass: rightsClassAccount,
  //           authority: provider.wallet.publicKey,
  //           tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
  //           receiverAddress: provider.wallet.publicKey,  
  //           rightsCoinFrom:rightsCoinToATARec,
  //           rightsCoinMint:rightCoinMintAddress,
  //           rightsCoinFromAuthority: provider.wallet.publicKey
  //         })
  //       .rpc();
  //       //.signers([provider])
  //       //.rpc();
  //     // const latestBlockhash = await provider.connection.getLatestBlockhash();
  //     // tx.recentBlockhash = latestBlockhash.blockhash;
  //     // tx.feePayer = provider?.wallet.publicKey;
  //     // let signed = await provider?.wallet.signTransaction(tx);
  //     // const rawTransaction = signed.serialize()
  //     console.log("response: ", response);
  //     //const keypair = anchor.web3.Keypair.fromSecretKey(secret);
  //     //const wallet_backend = new Wallet(keypair_backend);
  //     //const fullySignedTransaction = await wallet_backend.signTransaction(rawTransaction);
  //     //console.log("fullySignedTransaction: ", fullySignedTransaction);

  //     // const txid = await connection.sendRawTransaction(rawTransaction, {
  //     //   skipPreflight: true,
  //     //   maxRetries: 2
  //     // });
  //     // console.log("signature: ", txid);
  //     const rightsClass = await program.account.rightsClass.fetch(rightsClassAccount);
  //     console.log('rightsClass: ', rightsClass);
  //     setValue(true);
  //   } catch (err) {
  //     let index = err.toString().indexOf("Error Code:");
  //     let error_new = err.toString().substring(index);
  //     setError(error_new);
  //   }
  // }

  if (!wallet.connected) {
    /* If the user's wallet is not connected, display connect wallet button. */
    return (
      <div className="App"> 
          <div className='py-24'>
          <svg width="200" height="83" viewBox="0 0 722 300" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_202_2)"><path d="M195.475 209.49C195.475 209.49 195.475 209.245 195.44 209.141C195.23 207.848 194.811 206.695 194.217 205.717C192.4 202.049 189.046 198.905 185.168 197.753L94.331 170.645C88.5314 168.933 83.8498 172.217 83.8498 178.016C83.8498 183.815 88.5314 189.893 94.331 191.605L154.703 209.63L13.4858 250.536C6.04417 252.701 0 260.491 0 267.932V289.835C0 297.275 6.04417 301.572 13.4858 299.406L182.129 250.501C189.57 248.335 195.615 240.545 195.615 233.104V211.202C195.615 210.573 195.51 210.049 195.44 209.455L195.475 209.49Z" fill="#3A4774"></path><path d="M195.475 126.665C195.475 126.665 195.475 126.421 195.44 126.316C195.23 125.023 194.811 123.87 194.217 122.892C192.4 119.224 189.046 116.081 185.168 114.928L94.331 87.8202C88.5314 86.1085 83.8498 89.3921 83.8498 95.1909C83.8498 100.99 88.5314 107.068 94.331 108.78L154.703 126.805L13.4858 167.711C6.04417 169.877 0 177.666 0 185.107V207.01C0 214.45 6.04417 218.747 13.4858 216.581L182.129 167.676C189.57 165.51 195.615 157.72 195.615 150.279V128.377C195.615 127.748 195.51 127.224 195.44 126.63L195.475 126.665Z" fill="#3A4774"></path><path d="M195.475 39.3344C195.475 39.3344 195.475 39.0899 195.44 38.9851C195.23 37.6926 194.811 36.5398 194.217 35.5617C192.4 31.8938 189.046 28.7499 185.168 27.5971L94.331 0.45458C88.5314 -1.25711 83.8498 2.02654 83.8498 7.82533C83.8498 13.6241 88.5314 19.7024 94.331 21.4141L154.703 39.4392L13.4858 80.3801C6.04417 82.5459 0 90.3358 0 97.7764V119.679C0 127.12 6.04417 131.416 13.4858 129.251L182.129 80.3451C189.57 78.1793 195.615 70.3894 195.615 62.9488V41.0461C195.615 40.4173 195.51 39.8933 195.44 39.2995L195.475 39.3344Z" fill="#3A4774"></path></g><g clip-path="url(#clip1_202_2)"><path d="M666.135 91.3043C635.313 91.3043 610.271 117.794 610.271 150.396C610.271 182.998 635.313 209.488 666.135 209.488C696.957 209.488 721.999 182.998 721.999 150.396C721.999 117.794 696.957 91.3043 666.135 91.3043ZM666.135 197.347C641.654 197.347 621.748 176.291 621.748 150.396C621.748 124.501 641.654 103.445 666.135 103.445C690.616 103.445 710.521 124.501 710.521 150.396C710.521 176.291 690.616 197.347 666.135 197.347Z" fill="#3A4774"></path><path d="M535.063 209.402C546.622 209.402 558.18 205.496 567.571 198.28L570.38 196.157L572.788 198.704L583.463 209.996H599.677L580.814 190.129L578.406 187.582L580.413 184.695C587.155 174.762 590.847 162.536 590.847 150.31C590.847 117.708 565.805 91.2184 534.983 91.2184H396.125C379.912 91.2184 366.748 105.142 366.748 122.293V125.264C366.748 142.414 379.912 156.338 396.125 156.338H433.127C443 156.338 451.026 164.828 451.026 175.271V178.243C451.026 188.686 443 197.176 433.127 197.176H295.072C270.511 197.176 250.605 176.12 250.605 150.225C250.605 124.33 270.511 103.444 294.991 103.444C319.472 103.444 339.378 124.5 339.378 150.395C339.378 160.753 336.248 170.602 330.388 178.667H343.953C348.448 170.007 350.775 160.244 350.775 150.395C350.775 117.793 325.733 91.3033 294.991 91.3033C264.25 91.3033 239.127 117.793 239.127 150.395C239.127 182.997 264.09 209.317 294.751 209.487H433.127C449.341 209.487 462.504 195.563 462.504 178.413V175.441C462.504 158.291 449.341 144.367 433.127 144.367H396.125C386.253 144.367 378.226 135.877 378.226 125.434V122.462C378.226 112.019 386.253 103.529 396.125 103.529H535.063C559.544 103.529 579.45 124.585 579.45 150.48C579.45 159.055 577.283 167.375 573.109 174.677L570.46 179.262L566.848 175.441L539.077 146.065L530.97 154.64L558.822 184.016L562.434 187.837L558.019 190.639C551.116 195.053 543.25 197.346 535.144 197.346C510.663 197.346 490.757 176.29 490.757 150.395C490.757 140.037 493.888 130.188 499.747 122.123H486.182C481.687 130.783 479.36 140.462 479.36 150.395C479.36 182.997 504.402 209.487 535.224 209.487L535.063 209.402Z" fill="#3A4774"></path></g><defs><clipPath id="clip0_202_2"><rect width="195.649" height="300" fill="white"></rect></clipPath><clipPath id="clip1_202_2"><rect width="482.873" height="118.863" fill="white" transform="translate(239.127 91.3043)"></rect></clipPath></defs></svg>
        </div>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop:'100px' }}>
          <WalletMultiButton />
        </div>
      </div>
    )
  } else {
    return (
      <div className="App">
        <div className='py-24'>
          <svg width="200" height="83" viewBox="0 0 722 300" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_202_2)"><path d="M195.475 209.49C195.475 209.49 195.475 209.245 195.44 209.141C195.23 207.848 194.811 206.695 194.217 205.717C192.4 202.049 189.046 198.905 185.168 197.753L94.331 170.645C88.5314 168.933 83.8498 172.217 83.8498 178.016C83.8498 183.815 88.5314 189.893 94.331 191.605L154.703 209.63L13.4858 250.536C6.04417 252.701 0 260.491 0 267.932V289.835C0 297.275 6.04417 301.572 13.4858 299.406L182.129 250.501C189.57 248.335 195.615 240.545 195.615 233.104V211.202C195.615 210.573 195.51 210.049 195.44 209.455L195.475 209.49Z" fill="#3A4774"></path><path d="M195.475 126.665C195.475 126.665 195.475 126.421 195.44 126.316C195.23 125.023 194.811 123.87 194.217 122.892C192.4 119.224 189.046 116.081 185.168 114.928L94.331 87.8202C88.5314 86.1085 83.8498 89.3921 83.8498 95.1909C83.8498 100.99 88.5314 107.068 94.331 108.78L154.703 126.805L13.4858 167.711C6.04417 169.877 0 177.666 0 185.107V207.01C0 214.45 6.04417 218.747 13.4858 216.581L182.129 167.676C189.57 165.51 195.615 157.72 195.615 150.279V128.377C195.615 127.748 195.51 127.224 195.44 126.63L195.475 126.665Z" fill="#3A4774"></path><path d="M195.475 39.3344C195.475 39.3344 195.475 39.0899 195.44 38.9851C195.23 37.6926 194.811 36.5398 194.217 35.5617C192.4 31.8938 189.046 28.7499 185.168 27.5971L94.331 0.45458C88.5314 -1.25711 83.8498 2.02654 83.8498 7.82533C83.8498 13.6241 88.5314 19.7024 94.331 21.4141L154.703 39.4392L13.4858 80.3801C6.04417 82.5459 0 90.3358 0 97.7764V119.679C0 127.12 6.04417 131.416 13.4858 129.251L182.129 80.3451C189.57 78.1793 195.615 70.3894 195.615 62.9488V41.0461C195.615 40.4173 195.51 39.8933 195.44 39.2995L195.475 39.3344Z" fill="#3A4774"></path></g><g clip-path="url(#clip1_202_2)"><path d="M666.135 91.3043C635.313 91.3043 610.271 117.794 610.271 150.396C610.271 182.998 635.313 209.488 666.135 209.488C696.957 209.488 721.999 182.998 721.999 150.396C721.999 117.794 696.957 91.3043 666.135 91.3043ZM666.135 197.347C641.654 197.347 621.748 176.291 621.748 150.396C621.748 124.501 641.654 103.445 666.135 103.445C690.616 103.445 710.521 124.501 710.521 150.396C710.521 176.291 690.616 197.347 666.135 197.347Z" fill="#3A4774"></path><path d="M535.063 209.402C546.622 209.402 558.18 205.496 567.571 198.28L570.38 196.157L572.788 198.704L583.463 209.996H599.677L580.814 190.129L578.406 187.582L580.413 184.695C587.155 174.762 590.847 162.536 590.847 150.31C590.847 117.708 565.805 91.2184 534.983 91.2184H396.125C379.912 91.2184 366.748 105.142 366.748 122.293V125.264C366.748 142.414 379.912 156.338 396.125 156.338H433.127C443 156.338 451.026 164.828 451.026 175.271V178.243C451.026 188.686 443 197.176 433.127 197.176H295.072C270.511 197.176 250.605 176.12 250.605 150.225C250.605 124.33 270.511 103.444 294.991 103.444C319.472 103.444 339.378 124.5 339.378 150.395C339.378 160.753 336.248 170.602 330.388 178.667H343.953C348.448 170.007 350.775 160.244 350.775 150.395C350.775 117.793 325.733 91.3033 294.991 91.3033C264.25 91.3033 239.127 117.793 239.127 150.395C239.127 182.997 264.09 209.317 294.751 209.487H433.127C449.341 209.487 462.504 195.563 462.504 178.413V175.441C462.504 158.291 449.341 144.367 433.127 144.367H396.125C386.253 144.367 378.226 135.877 378.226 125.434V122.462C378.226 112.019 386.253 103.529 396.125 103.529H535.063C559.544 103.529 579.45 124.585 579.45 150.48C579.45 159.055 577.283 167.375 573.109 174.677L570.46 179.262L566.848 175.441L539.077 146.065L530.97 154.64L558.822 184.016L562.434 187.837L558.019 190.639C551.116 195.053 543.25 197.346 535.144 197.346C510.663 197.346 490.757 176.29 490.757 150.395C490.757 140.037 493.888 130.188 499.747 122.123H486.182C481.687 130.783 479.36 140.462 479.36 150.395C479.36 182.997 504.402 209.487 535.224 209.487L535.063 209.402Z" fill="#3A4774"></path></g><defs><clipPath id="clip0_202_2"><rect width="195.649" height="300" fill="white"></rect></clipPath><clipPath id="clip1_202_2"><rect width="482.873" height="118.863" fill="white" transform="translate(239.127 91.3043)"></rect></clipPath></defs></svg>
          <button className='button-connect float-right' onClick={disconnect} type='submit'>Disconnect</button>
        </div>
        <div className='div-padding-bottom'>
          <span className='text-bold'> Wallet Address: </span>
        </div>
        <div className='div-padding-bottom'>
          {wallet.publicKey.toString()}
        </div>
        {/* <div className='div-padding-bottom'>
        <span className='text-bold'> Amount: </span>100
        </div>
        <div className='div-padding-bottom'>
          <span className='text-bold'> Freeze Date: </span>2023-08-15
        </div> */}
        <div>
          {
            !value && (<><button onClick={setReceiverRightsClass} className="button" type="submit">Set Rights Class</button></>)
          }
          {
            value && <div> <div><span className='text-bold'> Signature: </span></div> {response} </div>
          }

          {/* {
            value && value >= Number(0) ? (
              <h2>{value}</h2>
            ) : (
              <h3>.</h3>
            )
          } */}
          {
            error && <div className='diverror'> {error.toString()}</div>
          }
        </div>
        {/* <div>
          <button onClick={approveReceiverRightsCoin} className="button" type="submit">Claim OSQO Coin</button>
        </div> */}
      </div>
    );
  }
}

/* wallet configuration as specified here: https://github.com/solana-labs/wallet-adapter#setup */
const AppWithProvider = () => (
  <ConnectionProvider endpoint="https://api.devnet.solana.com">
    <WalletProvider wallets={wallets} autoConnect>
      <WalletModalProvider>
        <App />
      </WalletModalProvider>
    </WalletProvider>
  </ConnectionProvider>
)

export default AppWithProvider;